import { useTheme } from '../../contexts/ThemeContext';
import { Button } from '../ui/button';
import { Sun, Moon, RefreshCw } from 'lucide-react';
import { refreshCosts } from '../../lib/api';
import { toast } from 'sonner';
import { useState } from 'react';

export const Header = ({ title, subtitle }) => {
  const { theme, toggleTheme } = useTheme();
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await refreshCosts();
      toast.success('Données rafraîchies avec succès');
      window.location.reload();
    } catch (error) {
      toast.error('Erreur lors du rafraîchissement');
    } finally {
      setRefreshing(false);
    }
  };

  const refreshClass = refreshing ? 'animate-spin' : '';

  return (
    <header className="flex items-center justify-between pb-6 border-b border-border mb-6" data-testid="page-header">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight font-[Outfit]" data-testid="page-title">{title}</h1>
        {subtitle && (
          <p className="text-muted-foreground mt-1" data-testid="page-subtitle">{subtitle}</p>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          onClick={handleRefresh}
          disabled={refreshing}
          data-testid="refresh-btn"
          className="h-9 w-9"
        >
          <RefreshCw className={'h-4 w-4 ' + refreshClass} />
        </Button>
        <Button
          variant="outline"
          size="icon"
          onClick={toggleTheme}
          data-testid="theme-toggle"
          className="h-9 w-9"
        >
          {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
        </Button>
      </div>
    </header>
  );
};
